import React from 'react';

import './ButtonSort.scss';

function ButtonSort({ sortOptions, sortingHandler }) {
  return (
    <div className="mn_buttonSort">
      <span className="mn_sortButtonsLabel">Sort by </span>
      {sortOptions && sortOptions.map((sortItem) => (
        <button
          data-view-name={sortItem.viewName}
          key={sortItem.sortBy}
          className={`mn_buttonInverted ${sortItem.className}`}
          onClick={e => sortingHandler(e, sortItem.sortBy)}
        >
          {sortItem.viewName}
        </button>
      ))}
    </div>
  );
}

export default ButtonSort;
